import { useSessionStorageState } from 'ahooks'
import { createContext, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import axiosBase from 'axios'
import { useAuthContext } from '../auth/useAuthContext'
import { HOST_API_KEY } from '../config-global'

const WhiteLabelContext = createContext({})

export function WhiteLabelSettingsProvider({ children }) {
  const { isOperator } = useAuthContext()
  const [whiteLabelSettings, setWhitelabelSettings] = useSessionStorageState('whiteLabelSettings', {
    defaultValue: {},
  })

  useEffect(() => {
    async function fetchWhitelabel() {
      if (isOperator) {
        return
      }

      try {
        const { data } = await axiosBase.get(`${HOST_API_KEY}/api/settings`, {
          headers: { 'X-Tenant': process.env.REACT_APP_TENANT_ID },
        })
        setWhitelabelSettings(data)
      } catch (err) {
        console.error('Failed to fetch whiteLabelSettings configuration:', err)
      }
    }

    if (!whiteLabelSettings?.id) {
      fetchWhitelabel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOperator])

  return (
    <WhiteLabelContext.Provider value={whiteLabelSettings}>{children}</WhiteLabelContext.Provider>
  )
}

WhiteLabelSettingsProvider.propTypes = {
  children: PropTypes.node,
}

export function useWhiteLabelSettings() {
  const context = useContext(WhiteLabelContext)
  if (context === null) {
    throw new Error('useWhiteLabel must be used within a WhiteLabelSettingsProvider')
  }
  return context
}
